// extracted by mini-css-extract-plugin
export default {"featureWrapper":"FareFeature-module__featureWrapper___gGZnj","infoIcon":"FareFeature-module__infoIcon___ZG8VO","featureContent":"FareFeature-module__featureContent___szUMB"};